export default __webpack_public_path__ + "static/media/buildingBusiness.adac4e0c.gif";